<template>
  <div class="p-3" :style="{ minHeight: `${itemHeight}px` }">
    <slot v-if="isVisible" v-bind="{ isVisible }">
      <template v-if="!!$props.column.date">
        {{ format($props.value, 'MM/DD/YYYY HH:mm A') }}
      </template>
      <template v-else>{{ $props.value }}</template>
    </slot>
  </div>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'
import { format } from 'date-fns'

import {
  BaseDataTableInjectionKey,
  BaseDataTableTableInjectionKey
} from './BaseDataTable.constants'

export default defineComponent({
  name: 'BaseDataTableTableCell',
  props: {
    index: {
      type: Number,
      required: true
    },
    column: {
      type: Object,
      required: true,
      validator: (value) => {
        const keys = Object.keys(value)

        return keys.every((key) => keys.includes(key))
      }
    },
    value: [String, Number, Boolean, Object, Array]
  },
  setup(props) {
    const { itemHeight } = inject(BaseDataTableInjectionKey)
    const { visibleIndexes } = inject(BaseDataTableTableInjectionKey)

    const isVisible = computed(() => visibleIndexes.value.includes(props.index))

    return {
      format,

      itemHeight,

      isVisible
    }
  }
})
</script>
